import ResetPassword from "../Auth/ResetPassword";
import SetupAccount from "../Auth/SetupAccount";

export const authRoutes = [
  { path: `${process.env.PUBLIC_URL}/setup-account`, Component: <SetupAccount /> },
  { path: `${process.env.PUBLIC_URL}/reset-password`, Component: <ResetPassword /> },
];
